const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Kiitos, kun rekisteröidyit BRIDGESTONE PLUS -palveluun.",
      content:
        "Hyvä,<br/>Kiitos rekisteröitymisestäsi. Meillä on ilo ilmoittaa, että BRIDGESTONE PLUS -rekisteröintisi on tarkistettu ja hyväksytty.<br/>Toivomme, että BRIDGESTONE PLUS tuo sinulle menestystä ja arvokkaita mahdollisuuksia, ja odotamme innolla yhteistyön jatkumista.<br/>Ystävällisin terveisin,<br/>BRIDGESTONE PLUS -tiimi",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Kiitos, kun rekisteröidyit BRIDGESTONE PLUS -palveluun.",
      content:
        "Hyvä,<br/>Kiitos rekisteröitymisestäsi. Meillä on ilo ilmoittaa, että BRIDGESTONE PLUS -rekisteröintisi on tarkistettu ja hyväksytty.<br/>Toivomme, että BRIDGESTONE PLUS tuo sinulle menestystä ja arvokkaita mahdollisuuksia, ja odotamme innolla yhteistyön jatkumista.<br/>Ystävällisin terveisin,<br/>BRIDGESTONE PLUS -tiimi",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
